import React from "react";
import { motion } from "framer-motion";
import { Users, Boxes } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}K` : `${n}`);

export const CommunityCard = ({ community, className = "" }) => {
  const [joined, setJoined] = React.useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4 }}
      className={cn("glass glass-hover group overflow-hidden rounded-2xl", className)}
      data-testid={`community-card-${community.slug}`}
    >
      <div className="h-16 w-full" style={{ background: `linear-gradient(120deg, ${community.color}55, transparent)` }} />
      <div className="px-5 pb-5">
        <div className="-mt-7 flex items-end justify-between">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 shadow-glass" style={{ background: `${community.color}22` }}>
            <Boxes className="h-6 w-6" style={{ color: community.color }} />
          </div>
          <button
            type="button"
            onClick={() => { setJoined((v) => !v); toast.success(joined ? `Left ${community.name}` : `Joined ${community.name}`); }}
            data-testid={`join-${community.slug}`}
            className={cn("rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wide transition-all",
              joined ? "border border-white/10 bg-white/5 text-slate-300" : "bg-cyan-400 text-[#050814] hover:bg-cyan-300")}
          >
            {joined ? "Joined" : "Join"}
          </button>
        </div>
        <h3 className="mt-3 font-heading text-lg font-bold text-white">{community.name}</h3>
        <p className="mt-1 line-clamp-2 text-sm text-slate-400">{community.description}</p>
        <div className="mt-4 flex items-center gap-4 text-xs text-slate-400">
          <span className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5" /> {fmt(community.members)} members</span>
          <span className="flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> {community.activeAgents} active
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default CommunityCard;
